import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { protectedRoutes } from "./AgentsAbilityRoutes";

const ProtectRedirectTo = "/login";
const AuthRedirectTo = "/";
const AdminRedirectTo = "/403";

//  pages access before login

export const PublicRoute = ({
  children,
  isAuthenticated = false,
  comingFrom = "",
}) => {
  return !isAuthenticated ? (
    children
  ) : (
    <Navigate to={comingFrom ? comingFrom : AuthRedirectTo} replace={true} />
  );
};

// pages access after login successfully

export const ProtectedRoute = ({
  children,
  isAuthenticated = false,
  redirto = "",
  useInfo = "",
}) => {
  if (useInfo?.status === "pending" && useInfo?.user_type === null) {
    return <Navigate to={"/customer-type"} replace={true} />;
  }
  if (
    (useInfo?.status === "pending" && useInfo?.user_type === "regular") ||
    (useInfo?.status === "pending" && useInfo?.user_type === "business")
  ) {
    return <Navigate to={"/pending-appproval"} replace={true} />;
  }

  if (useInfo?.status === "active" && !useInfo?.review_approved) {
    return <Navigate to={"/profile-approved"} replace={true} />;
  }
  if (useInfo?.status === "active" && !useInfo?.payment_method) {
    return <Navigate to={"/payment-method"} replace={true} />;
  }
  if (
    isAuthenticated &&
    (useInfo?.role === "admin" || useInfo?.role === "agent")
  ) {
    return <Navigate to={"/403"} replace={true} />;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={redirto ? redirto : ProtectRedirectTo} replace={true} />
  );
};

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, user: userInfo = {} } = useSelector(
    (state) => state?.auth
  );

  const isAdmin = userInfo?.role === "admin";
  const isAgent = userInfo?.role === "agent";
  const isUser = userInfo?.role === "user";

  const userAbilities = userInfo?.abilities || [];

  if (isAuthenticated && isUser) {
    return <Navigate to={"/403"} replace={true} />;
  }

  if (isAuthenticated && !isUser) {
    if (isAdmin) {
      return children;
    } else if (isAgent) {
      // check the current path
      const currentPath = window.location.pathname;
      // Find the matching route object for the current path
      const currentRoute = protectedRoutes.find((route) => {
        const regex = new RegExp(
          `^${route.path.replace(/\/:\w+/g, "/[^/]+")}$`
        );
        return currentPath.match(regex) !== null;
      });

      if (
        currentRoute &&
        userAbilities.includes(currentRoute.requiredAbility)
      ) {
        return children;
      } else {
        return <Navigate to={"/403"} replace={true} />;
      }
    }
  } else {
    return (
      <Navigate
        to={isAuthenticated && !isAdmin ? AdminRedirectTo : "/admin/login"}
        replace={true}
      />
    );
  }
};

export const AdminPublicRoute = ({ children }) => {
  const { isAuthenticated, user: useInfo = {} } = useSelector(
    (state) => state.auth
  );
  if (isAuthenticated) {
    if (useInfo.role === "user") {
      return <Navigate to="/403" replace={true} />;
    } else if (useInfo.role === "admin") {
      return <Navigate to="/admin/customers" replace={true} />;
    }
  }
  return children;
};
